<template>
    <div class="contenedor_cargando">
        <div class="caja_spinner">
            <b-spinner type="grow" label="Spinning"></b-spinner>
            <h3>{{ titulo }}</h3>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Cargando',
        props: ['titulo'],
        data() {
            return {

            }
        },
        methods: {

        },
    }
</script>

<style>
    .contenedor_cargando {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.8);
        z-index: 9999;
    }

    .caja_spinner {
        text-align: center;
    }
</style>